import React from 'react';
import type { Locales } from 'cms/cms-types';
import { type Filter, type ListingFiltersState } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { type ListingPaginationState } from '3-components/ListingApp/ListingPagination/ListingPagination';
import { type ListingUILabel } from '3-components/ListingApp/ListingUI/ListingUI';

export type AppStatus = 'initial-loading' | 'fetching' | 'initial-error' | 'error' | 'ready';

export interface CareerListingLabel extends ListingUILabel {
    title: string;
    clearFilterButton: string;
    noCareerMessage: string;
    noCareerEmail: string;
}

export interface CareerListingCMSConfig {
    apiUrl?: string;
    apiKey: string;
}

export interface CareerListingProps {
    locale?: Locales;
    cms: CareerListingCMSConfig;
    label: CareerListingLabel;
    listing: {
        filters?: Filter[];
        filterByAncestors?: string[];
        itemsPerPage: number;
    };
}

export interface CareerListingContextProps extends CareerListingProps, ListingFiltersState, ListingPaginationState {
    // appStatus: AppStatus;
    // setAppStatus: React.Dispatch<React.SetStateAction<AppStatus>>;
    // errorMessage: string;
    // setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

const CareerListingContext = React.createContext<Partial<CareerListingContextProps>>({});

export default CareerListingContext;
